import { render, staticRenderFns } from "./brands-performance-report.vue?vue&type=template&id=090c6771&scoped=true"
import script from "./brands-performance-report.vue?vue&type=script&lang=js"
export * from "./brands-performance-report.vue?vue&type=script&lang=js"
import style0 from "./brands-performance-report.vue?vue&type=style&index=0&id=090c6771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c6771",
  null
  
)

export default component.exports